import * as React from "react";
import type { SVGProps } from "react";

const SvgIconCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 15 15"
    {...props}
  >
    <path
      fill="#2458A9"
      fillRule="evenodd"
      d="M10.737 4.421 5.892 9.263 4.265 7.638a.83.83 0 0 0-1.17 0 .83.83 0 0 0 0 1.168l2.183 2.183c.01.01.012.023.022.035.162.16.377.239.592.239a.83.83 0 0 0 .588-.24c.012-.011.014-.026.025-.034l5.4-5.397a.83.83 0 0 0 0-1.17.83.83 0 0 0-1.168 0M7.501 0A7.5 7.5 0 0 1 15 7.5 7.5 7.5 0 1 1 7.5 0"
    />
  </svg>
);
export default SvgIconCheckmark;
